export default __webpack_public_path__ + "static/media/linus3-s.280bc88e.webp";